export function buildHeadline(args: {
  Q: number | null;
  V: number | null;
  d20: number | null;
  cPctile: number | null;
  hedgeActive: boolean;
  alphaStreak: number | null;
}): string | null {
  const parts: string[] = [];

  const qWord = args.Q == null ? null
    : args.Q >= 2.5 ? 'highest quality'
    : args.Q >= 1.5 ? 'high quality'
    : args.Q >= 0.5 ? 'good quality'
    : args.Q >= -0.5 ? 'average quality'
    : args.Q >= -1.5 ? 'below-average quality'
    : 'low quality';
  const vWord = args.V == null ? null
    : args.V >= 1.5 ? 'dirt cheap'
    : args.V >= 0.5 ? 'cheap'
    : args.V >= -0.5 ? 'fair price'
    : args.V >= -1.5 ? 'premium price'
    : 'expensive';
  if (qWord && vWord) {
    parts.push(`${qWord} and ${vWord}`);
  } else if (qWord) {
    parts.push(qWord);
  } else if (vWord) {
    parts.push(vWord);
  }

  if (args.d20 != null) {
    if (args.d20 >= 0.30) parts.push('trending higher');
    else if (args.d20 >= 0.15) parts.push('ticking up');
    else if (args.d20 <= -0.30) parts.push('rolling lower');
    else if (args.d20 <= -0.15) parts.push('ticking down');
  }

  if (args.cPctile != null) {
    if (args.cPctile >= 95) parts.push('at multi-year peak');
    else if (args.cPctile >= 85) parts.push('near multi-year peak');
    else if (args.cPctile <= 5) parts.push('at multi-year trough');
    else if (args.cPctile <= 15) parts.push('near multi-year trough');
  }

  if (args.alphaStreak != null) {
    if (args.alphaStreak === 1) parts.push('new in basket');
    else if (args.alphaStreak >= 30) parts.push(`${args.alphaStreak}-day streak`);
  }

  if (args.hedgeActive) parts.push('hedge advised');

  if (parts.length === 0) return null;
  return parts.join(' · ');
}
